import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown } from '@fortawesome/pro-light-svg-icons';

export function ThumbsDownIcon({ color = '' }) {
  const styleObj: React.CSSProperties = color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faThumbsDown} size="xs" />;
}
